import * as actions from "./statusKerjasama.actions";
import * as types from "./statusKerjasama.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { StatusKerjasamaReducerType } from "./types";

export type StatusKerjasamaActions = ActionType<typeof actions>;

export const initialState: StatusKerjasamaReducerType = {
  error: null,
  isLoading: false,
  errorMessage: '',
  redirectQueue: '',
  listStatusKerjasama: [],
  selectedStatusKerjasama: null,
};

export const StatusKerjasamaReducer = createReducer<
StatusKerjasamaReducerType,
  StatusKerjasamaActions
>(initialState)
  // GET JENIS DOKUMEN
  .handleAction(actions.getStatusKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getStatusKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    listStatusKerjasama: action.payload.data.items,
  }))
  .handleAction(actions.getStatusKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET JENIS DOKUMEN
  .handleAction(actions.getDetailStatusKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.getDetailStatusKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    selectedStatusKerjasama: action.payload.data,
  }))
  .handleAction(actions.getDetailStatusKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE JENIS DOKUMEN
  .handleAction(actions.updateStatusKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.updateStatusKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/status-kerjasama',
  }))
  .handleAction(actions.updateStatusKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE JENIS DOKUMEN
  .handleAction(actions.createStatusKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.createStatusKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/status-kerjasama',
  }))
  .handleAction(actions.createStatusKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_STATUS_KERJASAMA as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    selectedStatusKerjasama: action.payload.statusKerjasama,
  }))
  .handleAction(types.SELECT_STATUS_KERJASAMA as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedStatusKerjasama: action.payload.statusKerjasama,
  }))
  .handleAction(types.UPDATE_NAME as any, (state, action) => ({
    ...state,
    selectedStatusKerjasama: (() => {
      if (state.selectedStatusKerjasama) {
        return {
          ...state.selectedStatusKerjasama,
          STATUS_NAME: action.payload.name
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_STATUS as any, (state, action) => ({
    ...state,
    selectedStatusKerjasama: (() => {
      if (state.selectedStatusKerjasama) {
        return {
          ...state.selectedStatusKerjasama,
          STATUS: action.payload.status
        };
      } else {
        return null;
      }
    })(),
  }))
